import { Box } from "@design-system/Box/Box";
import { Text } from "@design-system/Text/Text";

import { ValueComponentProps } from "../../../Select";

type Props = ValueComponentProps;

export const Value = ({ value, options }: Props) => {
  return (
    <Box>
      <Text>{options.find((o) => o.id === value)?.label}</Text>
    </Box>
  );
};
